export const HOME_PAGE_NS = 'pages/HomePage';

export const i18n = {
  en: {
    dayZero: {
      welcomeTitle: 'Welcome to your personal Home page',
      description:
        'Customise your Home Page by pinning widgets from various dashboards and any existing pages for quick access.',
      getStarted: 'Get Started',
    },
    editView: {
      buttonTitle: 'Edit view',
      rightDrawerTitle: 'Manage Widgets',
      widgets: 'Widgets',
      pinnedItems: 'Pinned Items',
      noPinnedItems: 'No pinned items yet',
    },
    reports: {
      deleteConfirm: 'Are you sure to delete {{ reportName }}?',
    },
  },
};
